import {
  CLEAR_AUTH_ERRORS,
  GET_SIGNIN_ERRORS,
  GET_SIGNUP_ERRORS,
  SET_CURRENT_USER,
  SIGNIN_LOADING,
  SIGNUP_LOADING,
} from '../../redux/actions/Types'
import { isEmpty } from 'lodash'
import { triggerGoogleAnalyticsEvent } from '../../utils/Helper'

const initialState = {
  isAuthenticated: false,
  user: {},
  onboarding: false,
  loginError: null,
  registerError: null,
  signUpLoading: false,
  signInLoading: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        signUpLoading: false,
        signInLoading: false,
        isAuthenticated: !isEmpty(action.payload),
        onboarding: action.payload.onboarding,
        user: action.payload,
      }
    case GET_SIGNIN_ERRORS:
      triggerGoogleAnalyticsEvent('exception', {
        description:
          action.payload?.passwordincorrect ||
          action.payload?.emailnotfound ||
          'Error signing in',
      })
      return {
        ...state,
        signInLoading: false,
        loginError:
          action.payload?.passwordincorrect ||
          action.payload?.emailnotfound ||
          'Error signing in',
      }
    case GET_SIGNUP_ERRORS:
      triggerGoogleAnalyticsEvent('exception', {
        description: action.payload?.message || 'Error signing up',
      })
      return {
        ...state,
        signUpLoading: false,
        registerError: action.payload?.message || 'Error signing up',
      }
    case CLEAR_AUTH_ERRORS:
      return {
        ...state,
        loginError: null,
        registerError: null,
      }
    case SIGNUP_LOADING:
      return {
        ...state,
        signUpLoading: action.payload,
      }
    case SIGNIN_LOADING:
      return {
        ...state,
        signInLoading: action.payload,
      }
    default:
      return state
  }
}
